<!--
 * @Author: your name
 * @Date: 2021-04-01 16:42:24
 * @LastEditTime: 2022-03-16 18:23:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \hlglmh-pc-ui\src\views\iframe\iframe.vue
-->
<template>
  <div v-win-loading="loading" class="iframe-wrap">
    <iframe id="iframe" ref="iframe" :src="iframeUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Iframe',
  data() {
    return {
      iframeUrl: null,
      loading: false
    }
  },
  computed: {
    url() {
      return this.$route.query.url
    }
  },
  watch: {
    url: {
      handler(val) {
        this.loading = true
        this.iframeUrl = null
        setTimeout(() => {
          this.iframeUrl = val
        }, 200)
      },
      immediate: true
    },
    iframeUrl(val) {
      this.loading = true
    }
  },
  mounted() {
    this.$nextTick(() => {
      let iframe = document.querySelector('#iframe')
      let that = this
      iframe.onload = function () {
        that.loading = false
      }
    })
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.iframe-wrap {
  position: relative;
  height: 100%;
  iframe {
    display: block;
    width: 100%;
    height: calc(100vh - 67px);
  }
}
</style>
